import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useFormik } from "formik";
import { passwordValidate } from "../helper/validate";
import { useAuthStore } from "../store/store";
import { verifyPassword } from "../helper/helper";

export default function Password() {
  const navigate = useNavigate();
  const { email } = useAuthStore((state) => state.auth);

  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validate: passwordValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      let loginPromise = verifyPassword({ email, password: values.password });
      loginPromise.then((res) => {
        let { token } = res.data;
        localStorage.setItem("token", token);
        navigate("/Dashboard");
      });
    },
  });

  return (
    <div className="flex flex-col bg-white min-h-screen">
      <Toaster position="top-center" reverseOrder={false} />

      {/* Centered Password Section */}
      <div className="flex flex-grow items-center justify-center px-4">
        <div className="w-full max-w-sm bg-white shadow-lg rounded-lg p-6">
          <h1 className="text-2xl font-bold text-center mb-6">Enter your password</h1>
          <form className="w-full" onSubmit={formik.handleSubmit}>
            <input
              {...formik.getFieldProps("password")}
              className="w-full p-3 border rounded-lg mb-4"
              type="password"
              placeholder="Password"
            />
            <button
              className="w-full bg-red-500 text-white p-3 rounded-lg hover:bg-red-600"
              type="submit"
            >
              Log in
            </button>
          </form>
          <div className="text-center py-4">
            <span className="text-gray-500">
              Forgot Password? {" "}
              <Link className="text-red-500" to="/recovery">
                Recover Now
              </Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
